import { getVariantPrice, getAvailableVariantStock } from "@modules/product-helper";
var uniq = require("lodash.uniq");

export default {
    namespaced: false,
    // -----------------------------------------------------------------
    state: {
        customer: {
            reseller_id: null,
            pricesIncludingVat: localStorage.getItem('prices_including_vat') !== 'false',
            discount_percentage: 0,
            min_order_amount: 0
        },
        basket: {
            products: []
        }
    },
    // -----------------------------------------------------------------
    getters: {
        basket: state => {
            return state.basket;
        },
        customer: state => {
            return state.customer;
        },
        basketSize: state => {
            return state.basket.products.length;
        },
        basketErrors: (state, getters) => {
            let errors = [];

            const outOfStockProducts = state.basket.products.filter(p => getAvailableVariantStock(p.variant) === 0);

            if (outOfStockProducts.length) {
                errors.push({
                    issue: "out_of_stock",
                    products: outOfStockProducts
                });
            }

            const notEnoughStockProducts = state.basket.products.filter(p => p.amount > getAvailableVariantStock(p.variant));

            if (notEnoughStockProducts.length) {
                errors.push({
                    issue: "not_enough_stock",
                    products: notEnoughStockProducts
                });
            }

            if (getters.subTotal < state.customer.min_order_amount) {
                errors.push({
                    issue: "order_amount_too_low",
                    order_amount: getters.subTotal,
                    min_order_amount: state.customer.min_order_amount
                });
            }

            return errors;
        },
        isReseller: state => {
            return state.customer.reseller_id != null;
        },
        percentage: state => {
            return state.customer.reseller_id != null ? state.customer.discount_percentage * 100 : 0;
        },
        pricesIncludingVat: state => {
            return state.customer.pricesIncludingVat;
        },
        payByInvoice: state => {
            return state.customer.pay_by_invoice ? state.customer.pay_by_invoice : false;
        },
        subTotal: state => {
            let subTotal = 0;

            state.basket.products.forEach(p => {
                if (getAvailableVariantStock(p.variant) >= p.amount) {
                    subTotal += p.amount * getVariantPrice(p);
                }
            });

            return subTotal;
        },
        subTotalVatIncl: state => {
            let subTotalVatIncl = 0;

            state.basket.products.forEach(p => {
                if (getAvailableVariantStock(p.variant) >= p.amount) {
                    subTotalVatIncl += p.amount * getVariantPrice(p, true);
                }
            });

            return subTotalVatIncl;
        },
        vat: (state, getters) => {
            return getters.subTotalVatIncl - getters.subTotal;
        },
        totalPrice: (state, getters) => {
            return getters.subTotal + getters.vat;
        }
    },
    // -----------------------------------------------------------------
    mutations: {
        CLEAR_BASKET(state) {
            state.basket.products = [];
        },
        ADD_BASKET_PRODUCT(state, product) {
            const filteredProduct = state.basket.products.find(p => {
                return p.productData.id === product.productData.id && p.variant.id === product.variant.id;
            });

            if (filteredProduct != null) {
                filteredProduct.amount += product.amount;
            } else {
                state.basket.products.push(product);
            }
        },
        UPDATE_BASKET_PRODUCT_AMOUNT(state, data) {
            const filteredProduct = state.basket.products.find(p => {
                return p.variant.id === data.variant_id;
            });

            if (filteredProduct != null) {
                if (data.amount >= 1) {
                    filteredProduct.amount = data.amount;
                } else {
                    const index = state.basket.products.findIndex(p => p.productData.id === data.id);
                    state.basket.products.splice(index, 1);
                }
            }
        },
        UPDATE_BASKET_PRODUCTS(state, products) {
            products.forEach(p => {
                const basketProduct = state.basket.products.find(bp => bp.productData.id === p.id);

                if (basketProduct) {
                    basketProduct.productData = p;
                    basketProduct.variant = p.variants.find(v => v.id === basketProduct.variant.id);
                }
            });
        },
        DELETE_BASKET_PRODUCT(state, variant_id) {
            const index = state.basket.products.findIndex(p => p.variant.id === variant_id);
            state.basket.products.splice(index, 1);
        },
        SET_PRICES_INCLUDING_VAT(state, value) {
            state.customer.pricesIncludingVat = value;
            localStorage.setItem('prices_including_vat', value)
        },
        SET_CUSTOMER(state, customer) {
            state.customer = customer;
        }
    },
    // -----------------------------------------------------------------
    actions: {
        clearBasket(context) {
            context.commit("CLEAR_BASKET");
        },
        addProduct(context, product) {
            context.commit("ADD_BASKET_PRODUCT", product);
        },
        deleteProduct(context, variant_id) {
            context.commit("DELETE_BASKET_PRODUCT", variant_id);
        },
        updateProductAmount(context, data) {
            context.commit("UPDATE_BASKET_PRODUCT_AMOUNT", data);
        },
        syncBasketProducts({ commit, state, rootState }, products) {
            const queryParams = uniq(
                state.basket.products.map(p => {
                    return p.productData.id;
                })
            );
            return rootState.api
                .get(`/api/products?ids=${queryParams.join(",")}`)
                .then(response => {
                    commit("UPDATE_BASKET_PRODUCTS", response.data);
                    return Promise.resolve(response.data);
                })
                .catch(e => {
                    return Promise.reject(e);
                });
        },
        setPricesIncludingVat(context, value) {
            context.commit("SET_PRICES_INCLUDING_VAT", value);
        },
        setCustomer(context, customer) {
            context.commit("SET_CUSTOMER", customer);
        }
    }
};
